import React from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import { appearancePropTypes } from '../utils/appearance';
import styleFactory from './contact-field.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ContactField = props => {
  var handleChange = event => {
    props.onValueChange(event);
  };
  var styles = styleFactory(props.appearance);
  var inputStyle = [styles.input, props.fieldError && styles.inputError];
  var Icon = props.icon;
  return ___EmotionJSX("div", {
    css: styles.textFieldWrapper
  }, Icon && ___EmotionJSX(Icon, {
    size: "custom",
    css: styles.icon
  }), ___EmotionJSX("input", {
    type: "text",
    name: props.fieldName,
    placeholder: props.placeHolder,
    value: props.fieldValue,
    onChange: handleChange,
    css: inputStyle
    // invalid 'disabled' property used on purpose to override browser
    ,
    autoComplete: props.media.mobile ? 'disabled' : 'on'
  }), ___EmotionJSX("div", {
    css: styles.errorMessage
  }, props.fieldError ? props.fieldError : ''));
};
ContactField.propTypes = {
  icon: PropTypes.func,
  fieldName: PropTypes.string.isRequired,
  placeHolder: PropTypes.string,
  fieldValue: PropTypes.string,
  fieldError: PropTypes.string,
  onValueChange: PropTypes.func,
  appearance: appearancePropTypes.isRequired,
  media: PropTypes.shape({
    mobile: PropTypes.bool
  })
};
ContactField.defaultProps = {
  icon: null,
  placeHolder: null,
  fieldValue: null,
  fieldError: null,
  onValueChange: () => {},
  media: {}
};
export default withMedia(ContactField);
export { ContactField as baseContactField };